import '../../../styles/Pages/PerformanceLeage.scss';
type BarItem = {
    id: string
    label: string;
    color: string;
    value: number; 
};
interface IPropsPerformanceLeage {
    dataBar: BarItem[];
}

const PerformanceLeage = ( { dataBar }: IPropsPerformanceLeage) => {
    const wrapperHeightPx = 200;

    return (
        // contenedor aislado para evitar que Tailwind afecte estilos internos
        <div className="pl-isolated col-span-6 pb-8" data-component="PerformanceLeage">
            <div className="pl-container">
                <h2 className="pl-heading">Liga de desempeño Premier</h2>

                <div className="pl-vertical-chart">
                    <div
                        className="pl-vertical-chart__bars"
                        role="group"
                        aria-label="Comparativo de tres columnas" >
                        {dataBar.map((item, idx) => {
                            const pct = Math.max(0, Math.min(100, item.value));
                            const pixelHeight = Math.round((pct / 100) * wrapperHeightPx);
                            return (
                                <div key={item.label} className="pl-vertical-chart__column">
                                    <div className="pl-vertical-chart__bar-wrapper" aria-hidden style={{ height: `${wrapperHeightPx}px`}}>
                                        <div
                                            className="pl-vertical-chart__bar"
                                            style={{
                                                height: `${pct}%`,
                                                minHeight: `${Math.max(6, pixelHeight)}px`,
                                                width: '150px',
                                                marginTop: `${wrapperHeightPx - pixelHeight}px`,
                                                ['--pl-bar-color' as any]: item.color,
                                                ['--pl-bubble-seed' as any]: idx,
                                                ['--pl-bubble-speed' as any]: `${6 + idx * 1.5}s`,
                                                ['--pl-bubble-delay' as any]: `${idx * 0.6}s`
                                            }}
                                            title={`${item.label}: ${item.value}%`}
                                            role="img"
                                            aria-label={`${item.label} ${item.value} percent`} >
                                            <div className="pl-bubble-layer" />
                                        </div>
                                    </div>
                                    <div className="pl-vertical-chart__label" aria-hidden style={{ fontWeight: 700}}>
                                        {item.value}%
                                    </div>
                                    <div className="pl-vertical-chart__label">{item.label}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PerformanceLeage;